/**
 * Copyright (c) 2026 Finorda Pty Ltd
 * All rights reserved.
 *
 * This file is part of the Finorda platform.
 * Unauthorised copying, modification or
 * distribution of this software is
 * strictly prohibited.
 *
 * Proprietary and confidential.
 * Governed by Queensland law, Australia.
 */

import { initSentry } from './utils/sentryInit'
initSentry()
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { AuthProvider } from './context/AuthContext'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false
    }
  }
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)
